import {Component, OnDestroy, OnInit} from '@angular/core';
import {IBreadcrumb} from '../../../eca-breadcrumb/models/breadcrumb.interface';
import {EcaBreadcrumbService} from '../../../eca-breadcrumb/services/eca-breadcrumb.service';
import {IUserInfo} from '../../../users/models/userInfo.interface';
import {Subscription} from 'rxjs';
import {OurUserService} from '../../../users/services/user.service';
import {consts} from '../../../common/modals/consts';

@Component({
  selector: 'app-help-page',
  templateUrl: './help-page.component.html',
  styleUrls: ['./help-page.component.scss']
})
export class HelpPageComponent implements OnInit , OnDestroy{
  public loggedInUser: IUserInfo;
  private loggedInUserSubscription: Subscription;
  companyId: string = consts.emptyGuid;
  constructor( private ecaBreadcrumbService: EcaBreadcrumbService,
               private userService: OurUserService,) { }

  ngOnInit(): void {
    this.userService.getLoggedInUser().subscribe(user => {
      this.loggedInUser = user;
      this.companyId = this.loggedInUser.companyId;
      this.loggedInUserSubscription = this.userService.getLoggedInUserSubject().subscribe( user => {
        this.loggedInUser = user;
        this.companyId = this.loggedInUser.companyId;
        this.populateBreadcrumbs();
      });
    });
  }
  ngOnDestroy() {
    this.loggedInUserSubscription.unsubscribe();
  }

  private populateBreadcrumbs() {
    const operativeBreadCrumbs = new Array<IBreadcrumb>();
    operativeBreadCrumbs.push({label: this.loggedInUser?.companyName?.toString() + ' - ' +  'Help', iconName: 'question'} as IBreadcrumb);
    this.ecaBreadcrumbService.breadCrumbs.next(operativeBreadCrumbs);
  }

  openRiskHelp() {

  }
}
